var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"icon-fade","mode":"out-in"}},[(_vm.imageSrc)?_c('img',{attrs:{"src":_vm.imageSrc}}):_c('Icon',{staticClass:"text-white fill-current opacity-50",attrs:{"name":"logo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }